export default ({children}) => {

  return (
    <div className="back">
      {children}
    </div>
  )
}